// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BlockRecommendedContent__recommended-content___ovP06 h3 h3{font-size:20px;font-weight:bold;text-transform:uppercase}", "",{"version":3,"sources":["webpack://./src/components/BlockRecommendedContent/BlockRecommendedContent.scss"],"names":[],"mappings":"AAEI,4DACE,cAAA,CACA,gBAAA,CACA,wBAAA","sourcesContent":[".recommended-content {\n  h3 {\n    h3 {\n      font-size: 20px;\n      font-weight: bold;\n      text-transform: uppercase;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recommended-content": "BlockRecommendedContent__recommended-content___ovP06"
};
export default ___CSS_LOADER_EXPORT___;
